angular.module('env.data.services.intune', [])

    .run(function (intuneService) {

    })

    .provider('intuneService', function (EventingMixin) {
        var _this = this;

        this.$get = function ($log, $q, $timeout, $localStorage, $http, authService) {

            /**
             * Gets list of managed devices that are currently registered in the Intune for the corresponding OM instance
             * @returns {Promise} Future object
             */
            _this.getManagedDevices = function () {
                var token = authService.getToken();
                if (!token) {
                    $log.error('Can not fetch managed devices info from OM Intune api. Error: Not authorized.');
                    return [];
                }
                var config = {headers: {Authorization: token}};

                return $http
                    .get(om.config.build.baseUrl + "/intune/managed-devices", config)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not fetch managed devices info from OM Intune api. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            return _this;
        };


    });
